import gql from 'graphql-tag'

const getTrelloList = gql`
  query getTrelloLists($token: String!, $board_id: String!) {
    getTrelloLists(token: $token, board_id: $board_id) {
      id
      name
    }
  }
`

export default getTrelloList
